import {FC, useRef} from "react";
import {CameraIcon} from "../atoms/Icon";

interface Props {
    onPhoto: (file: File) => void,
    disabled?: boolean
}

const ChatPhotoInput: FC<Props> = ({onPhoto, disabled}) => {
    const inputRef = useRef<HTMLInputElement>(null)

    const onMainButtonClick = () => {
        if (disabled) return;
        inputRef.current?.click()
    }

    return <>
        <input type="file" capture accept="image/*" style={{display: 'none'}} ref={inputRef} onChange={(e) => e.target.files && onPhoto(e.target.files[0])} />
        <CameraIcon size={20} onClick={onMainButtonClick} />
    </>
}

export default ChatPhotoInput